import React from 'react';

interface HighlightAnnouncementModalProps {
  isOpen: boolean;
  isHighlighting: boolean;
  title?: string;
  onClose: () => void;
  onConfirm: () => void;
}

const HighlightAnnouncementModal: React.FC<HighlightAnnouncementModalProps> = ({
  isOpen,
  isHighlighting,
  title,
  onClose,
  onConfirm,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4 p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-4 mb-4">
          <div className="flex-shrink-0 w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
            <svg className="w-6 h-6 text-amber-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l2.099 6.456a1 1 0 00.95.69h6.787c.969 0 1.371 1.24.588 1.81l-5.49 3.99a1 1 0 00-.364 1.118l2.099 6.456c.3.921-.755 1.688-1.54 1.118l-5.49-3.99a1 1 0 00-1.175 0l-5.49 3.99c-.784.57-1.838-.197-1.539-1.118l2.099-6.456a1 1 0 00-.364-1.118l-5.49-3.99c-.783-.57-.38-1.81.588-1.81h6.787a1 1 0 00.95-.69l2.099-6.456z"
              />
            </svg>
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900">Highlight Announcement</h3>
            <p className="text-sm text-gray-500 mt-1">Are you sure you want to set this announcement as the current highlight?</p>
          </div>
        </div>

        {title && (
          <div className="bg-gray-50 rounded-lg p-3 mb-4">
            <p className="text-sm font-medium text-gray-900">{title}</p>
          </div>
        )}

        <p className="text-sm text-gray-600 mb-6">
          This will replace the existing highlighted announcement.
        </p>

        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            disabled={isHighlighting}
            className="px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isHighlighting}
            className="px-4 py-2 text-sm font-semibold text-white bg-wine-100 rounded-lg hover:bg-wine-200 disabled:opacity-50"
          >
            {isHighlighting ? 'Highlighting...' : 'Highlight'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HighlightAnnouncementModal;
